import { Typography, Box, Button, Alert, Grid2 as Grid, Chip } from '@mui/material';
import { FC } from 'react';
import { Add, Delete } from '@mui/icons-material';

import { JobseekerCreateDto } from '@libs/dto';
import { useForm } from '@carcareers/contexts';
import { TextInput, DateInput } from '@carcareers/components';

export const ExperienceStep: FC = () => {
  const { data, setData } = useForm<JobseekerCreateDto>();
  const experiences = data?.experiences || [];

  const addExperience = () => {
    const newExperience = {
      title: '',
      company: '',
      description: '',
      current: false,
      startDate: '',
      endDate: '',
    };
    setData('experiences', [...experiences, newExperience]);
  };

  const removeExperience = (index: number) => {
    const updatedExperiences = experiences.filter((_, i) => i !== index);
    setData('experiences', updatedExperiences);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography variant="h5" component="h2" sx={{ fontWeight: 600 }}>
          Experience
        </Typography>
        {data?.resume && <Chip label="Optional" color="default" size="small" />}
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
        <Button startIcon={<Add />} onClick={addExperience}>
          Add Experience
        </Button>
      </Box>

      {experiences.map((_, index) => (
        <Box key={index} sx={{ border: 1, borderColor: 'divider', borderRadius: 1, p: 3 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="subtitle1">Experience #{index + 1}</Typography>
            <Button startIcon={<Delete />} color="error" onClick={() => removeExperience(index)}>
              Remove
            </Button>
          </Box>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextInput label="Job Title" name={`experiences.${index}.title`} fullWidth required />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextInput label="Company" name={`experiences.${index}.company`} fullWidth required />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextInput label="Description" name={`experiences.${index}.description`} multiline rows={3} fullWidth />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <DateInput label="Start Date" name={`experiences.${index}.startDate`} />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <DateInput label="End Date" name={`experiences.${index}.endDate`} />
            </Grid>
          </Grid>
        </Box>
      ))}

      {experiences.length === 0 && (
        <Alert severity="info">Click "Add Experience" to start adding your work history.</Alert>
      )}
    </Box>
  );
};

export default ExperienceStep;
